import * as Yup from 'yup';
import checkoutFormModel from './checkoutFormModel';
const {
  formField: {
    firstName,
    address1,
    city,
    zipcode,
    country,
  }
} = checkoutFormModel;


export default [
  Yup.object().shape({
    [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),

    [zipcode.name]: Yup.string()
      .required('CPF/CNPJ é obrigatório')
      .test('cpf-cnpj', 'CPF ou CNPJ inválido', (v) => {
        if (!v) return false;
        const d = v.replace(/\D/g, '');
        if (d.length === 11) {
          if (/^(\d)\1{10}$/.test(d)) return false;
          let s = 0; for (let i = 0; i < 9; i++) s += parseInt(d[i]) * (10 - i);
          let r = (s * 10) % 11; if (r === 10 || r === 11) r = 0;
          if (r !== parseInt(d[9])) return false;
          s = 0; for (let i = 0; i < 10; i++) s += parseInt(d[i]) * (11 - i);
          r = (s * 10) % 11; if (r === 10 || r === 11) r = 0;
          return r === parseInt(d[10]);
        }
        if (d.length === 14) {
          if (/^(\d)\1{13}$/.test(d)) return false;
          const calc = (str, n) => { let s = 0, p = n - 7; for (let i = 0; i < n; i++) { s += parseInt(str[i]) * p--; if (p < 2) p = 9; } const r = s % 11; return r < 2 ? 0 : 11 - r; };
          return calc(d, 12) === parseInt(d[12]) && calc(d, 13) === parseInt(d[13]);
        }
        return false;
      }),
  }),

];
